(function () {
    'use strict';

    angular.module("imApp").factory("checkInMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 507,
                    parameters: parms || {}
                });
            },
            checkInOutPortalUser: function (coords) {
                return $ihttp.post({
                    method: 506,
                    parameters: coords
                });
            }
        };

        return service;
    }]);
})();
